import { mande } from 'mande'

export const api = mande('/api', {
  credentials: 'include',
})

type SessionReturnType = {
  id: string
  userId?: string
  email?: string
}
let startSessionPromise:
  | ReturnType<typeof api.post<SessionReturnType>>
  | undefined = undefined
export const startSession = async () => {
  // return api.post<SessionReturnType>('/session')
  if (!startSessionPromise) {
    startSessionPromise = api
      .post<SessionReturnType>('/session')
      .finally(() => {
        startSessionPromise = undefined
      })
  }
  return startSessionPromise
}

export const getSession = async () => {
  return api.get<SessionReturnType>('/session')
}

export const login = async (email: string, password: string) => {
  return api.post('/auth/login/passw', {
    email,
    password,
  })
}

export const signup = async (email: string, password: string) => {
  return api.post('/auth/signup/passw', {
    email,
    password,
  })
}

export const logout = async () => {
  return api.post('/auth/logout')
}

export const getProfile = async () => {
  return api.get<{
    currentId: string
    profiles: Record<string, { id: string; name: string }>
  }>('/profile')
}

export const addProfile = async (id: string, name: string) => {
  return api.post('/profile', {
    id,
    name,
  })
}

export const removeProfile = async (id: string) => {
  return api.delete(`/profile/${id}`)
}

export const getUsage = async (profileId?: string) => {
  return api.get<{ completedSets: number }>(`/usage`, {
    query: {
      profileId,
    },
  })
}

export const forgotPassword = async (email: string) => {
  return api.post('/auth/forgot_password', {
    email,
  })
}

export const getCustomer = async () => {
  return api.get<{ status_code: number }>('/customer')
}

export const getFeatures = async (profileId?: string) => {
  return api.get<{ config: Record<string, any> }>('/feature', {
    query: {
      profileId,
    },
  })
}

/** @ts-nocheck debugging */
;(globalThis as any).getUsage = getUsage
